import React from "react";
import logo from "./logo.svg";
import Layout, { TAB_LOOKUP } from "./Layout";
import ArrowButton from "./ArrowButton";

import image1 from "./images/explore-image-1.jpg";
import image2 from "./images/explore-image-2.jpg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { t } from "i18next";

import "./ExploreScreen.scss";

function ExploreScreen() {
	
	 console.log (process.env.REACT_APP_LANGUAGE || "en")

 let locale = process.env.REACT_APP_LANGUAGE || "en";

 let url="https://www.avaya.com/"+locale+"/onecloud/";
 let url2="https://www.avaya.com/"+locale+"/onecloud-experience-builders/";
 
  const { t, i18n } = useTranslation();

  return (
    <div className="explore-screen-container fill-absolute">
      <div className="container row">
        <div className="flex">
          <img src={image1} alt="lady at a laptop" />

          <h2 className="green-header">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Contact.title1_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </h2>
          <p>{t("Contact.desc1")}</p>

          <a
            href={url}
            className="blue-button-container drop-shadow"
            style={{ width: 290, marginTop: 40 }}
          >
            {t("Contact.button1")}
          </a>
        </div>
        {/* <div style={{flex:0.5}} /> */}
        <div className="flex mobile-nav-padding">
          <img src={image2} alt="smiling guy at a laptop" />

          <h2 className="blue-header">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Contact.title2_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </h2>
          <p>{t("Contact.desc2")}</p>
          <a
            href={url2}
            className="blue-button-container drop-shadow"
            style={{ width: 320, marginTop: 40 }}
          >
            {t("Contact.button2")}
          </a>
          <div style={{ height: 60 }} />
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/partner-ecosystem" side="left"></ArrowButton>
        <ArrowButton to="/awards" side="right"></ArrowButton>
      </div>
    </div>
  );
}

export default ExploreScreen;
